import { useReadQuery } from '@apollo/client';
import { StreamType } from '@/__generated__/graphql.ts';
import { hasRightsToStream } from '@/components/streams/stream-banner/has-rights-to-stream.ts';
import { useMe } from '@/routes/_app/use-me.ts';
import {
  AuthenticatedStreamLoaderData,
  useStreamLoaderData,
} from '../_app.p.streams_.$id/loader.ts';
import { DelayedPreviewAlert } from './delayed-preview-alert.tsx';

export const AuthenticatedStreamPreviewAlert = () => {
  const { streamQueryRef } =
    useStreamLoaderData() as AuthenticatedStreamLoaderData;
  const {
    data: { stream },
  } = useReadQuery(streamQueryRef);
  const me = useMe();

  if (!stream) {
    return null;
  }

  const isMe = me.username === stream.author.username;
  const accessAllowed = isMe || stream.accessAllowed;

  const showPreviewAlert =
    !accessAllowed &&
    !stream.customTargetsData &&
    stream.streamType === StreamType.Public;

  if (!showPreviewAlert) {
    return null;
  }

  const requiresSubscription =
    !!stream.paidData?.length && !hasRightsToStream(stream);

  return (
    <DelayedPreviewAlert>
      {requiresSubscription
        ? 'This is a delayed preview. Subscribe to see new posts in real time.'
        : 'This is a delayed preview. Follow the stream to see new posts in real time.'}
    </DelayedPreviewAlert>
  );
};
